// appLyrics namespace — LyricsEditor.tsx (edytor tekstu per-utwór: TEKST + SYNC,
// prawdziwa transkrypcja + wykryte BPM). Keys mirror en/appLyrics.ts exactly.
// Sesja 32 (artboardy 05a–08e): stan transkrypcji to JEDNO krótkie zdanie nad listą
// (`state`), okno wyjścia bez zapisu i okno podglądu mają własne teksty.
export const appLyrics = {
  crumb: {
    library: 'Biblioteka',
    music: 'Muzyka',
  },
  // Jedno KRÓTKIE zdanie nad listą linii (R3, zasada 8): drugie zdanie-instrukcja
  // wyleciało, bo edytor i tak jest edytowalny w każdym stanie.
  state: {
    processing: 'Transkrypcja trwa.',
    instrumental: 'Nie wykryliśmy słów.',
    failed: 'Transkrypcja się nie udała.',
  },
  error: {
    title: 'Nie udało się wczytać tekstu.',
    retry: 'Spróbuj ponownie',
  },
  tabs: {
    label: 'Tryb edytora',
    text: 'Tekst',
    sync: 'Synchronizacja',
  },
  text: {
    heading: 'Tekst utworu',
    lineLabel: 'linia {n}',
    linePlaceholder: 'Wpisz słowa tej linii',
    addLine: 'Dodaj linię',
    removeLine: 'Usuń linię {n}',
    seekTo: 'Przewiń do {time}',
  },
  sync: {
    timeline: 'Oś czasu',
    selectedWord: 'Zaznaczone słowo',
    move: 'Przesuń',
    length: 'Długość',
    moveLabel: 'Start słowa „{word}” w sekundach',
    lengthLabel: 'Długość słowa „{word}” w sekundach',
    earlier: 'Wcześniej o {step} s',
    later: 'Później o {step} s',
    shorter: 'Krócej o {step} s',
    longer: 'Dłużej o {step} s',
    snap: 'Przyciągnij',
  },
  // Okno podglądu (artboard 08c): kadr 9:16 z linią z edytora.
  preview: {
    show: 'Podgląd',
    play: 'Odtwórz',
    close: 'Zamknij',
  },
  // Okno wyjścia bez zapisu (artboard 08d): „Zostań” jest bezpieczne i ma fokus.
  leave: {
    title: 'Wyjść bez zapisu?',
    body: 'Niezapisane zmiany przepadną.',
    stay: 'Zostań',
    leave: 'Wyjdź',
  },
  // „Zatwierdź tekst” (M4, `R5-14b`): jedna wypełniona akcja ekranu, dopóki tekst
  // nie jest zatwierdzony. Cofnięcia nie ma — wraca się przez ponowną analizę.
  approve: {
    submit: 'Zatwierdź tekst',
    done: 'Tekst zatwierdzony.',
    failed: 'Nie udało się zatwierdzić tekstu.',
  },
  save: {
    unsaved: 'Niezapisane zmiany',
    saved: 'Zapisano',
    saving: 'Zapisuję…',
    error: 'Zapis się nie powiódł. Spróbuj ponownie.',
    submit: 'Zapisz tekst',
  },
}
